export enum OnlineStatus {
  Offline,
  Online,
}

export const toOnlineStatus = (v?: boolean) => (v ? OnlineStatus.Online : OnlineStatus.Offline);
